import { FormErrors } from 'redux-form';

export interface DaikinFormData {
  full_address?: string;
  address?: string;
  zip?: string;
  locality?: string;
  state?: string;
  country_iso2?: string;
  lat?: number;
  lon?: number;
  how_many?: string;
  pe_installation?: string;
  product_choice?: string;
  pricing?: string;
  indicative_pricing?: string;
  subsidies?: string;
  note_select?: string;
  customer_note?: string;
  your_email?: string;
  info_pack?: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  scope_pdf?: string;
  prepared_by?: string;
  hear_about?: string;
  send_sms?: string;
  sms_template?: string;
  summary?: string;
}

export const validate = (values: DaikinFormData) => {
  let errors: FormErrors<DaikinFormData> = {};
  errors.full_address = validator(['required'], values.full_address);
  errors.how_many = validator(['required'], values.how_many);
  errors.pe_installation = validator(['required'], values.pe_installation);
  errors.product_choice = validator(['required'], values.product_choice);
  errors.indicative_pricing = validator(['required'], values.indicative_pricing);
  errors.note_select = validator(['required'], values.note_select);
  errors.your_email = validator(['required', 'validate_email'], values.your_email);
  errors.info_pack = validator(['required'], values.info_pack);
  errors.first_name = validator(['required'], values.first_name);
  errors.last_name = validator(['required'], values.last_name);
  errors.phone_number = validator(['required', 'validate_phone_number'], values.phone_number);
  errors.prepared_by = validator(['required'], values.prepared_by);
  errors.hear_about = validator(['required'], values.hear_about);
  errors.send_sms = validator(['required'], values.send_sms);
  errors.sms_template = validator(['required'], values.sms_template);
  return errors;
}

const validator = (attrs: string[], value: any) => {
  let errorTxt = '';
  attrs.forEach((item: string) => {
    switch (item) {
      case 'required':
        if (!value) errorTxt = 'This field is required '
        break;
      case 'validate_email':
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,9}$/i.test(value)) {
          errorTxt = 'Invalid email address '
        }
        break;
      case 'validate_phone_number':
        if (!/\(?([0-9]{4})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/i.test(value)) errorTxt = "Invalid phone number"
        break;
      default:
        break;
    }
  });
  return errorTxt;
}